<template>
  <b-modal id="bibangReviewRegModal" title="비방 리뷰 등록" size="lg" @hidden="fn_reset">
    <div class="search user_modal review_form">
      <div class="qa_block" v-for="(q, qIndex) in questionGroups" :key="q.key">
        <p class="qa_title">{{ qIndex + 1 }}. {{ q.title }}</p>
        <div class="card_select">
          <button
            type="button"
            v-for="opt in q.options"
            :key="opt.code"
            class="card_option"
            :class="{ active: answers[q.key] === opt.code }"
            @click="fn_select_answer(q.key, opt.code)"
          >{{ opt.label }}</button>
        </div>

        <div class="modify_note" v-if="q.key === 'usage_type' && answers.usage_type === 'MODIFIED'">
          <p class="qa_sub_title">가감 내용을 간단히 입력해주세요</p>
          <input type="text" class="form_control" v-model="modification_note" placeholder="가감 내용을 입력해주세요" />
        </div>
      </div>

      <div class="qa_block">
        <p class="qa_title">6. 비방의 임상 활용도를 평가해 주세요.</p>
        <div class="card_select">
          <button
            type="button"
            v-for="opt in ratingOptions"
            :key="opt.value"
            class="card_option"ting
            :class="{ active: ra=== opt.value }"
            @click="clinical_rating = opt.value"
          >{{ opt.value }}점: {{ opt.label }}</button>
        </div>
      </div>

      <div class="qa_block">
        <p class="qa_title">7. 사용 경험을 자유롭게 작성해 주세요.</p>
        <textarea class="form_control" rows="4" v-model="review_contents"></textarea>
      </div>
    </div>
    <template #modal-footer="{ ok }">
      <b-button @click="() => fn_close_review(ok)" class="btn btn_md btn_brown btn_outline">
        취소
      </b-button>
      <b-button @click="fn_reg_review" class="btn btn_md btn_brown">저장</b-button>
    </template>

    <alert-modal
      :id="'bibangReviewAlert'"
      :text="showAlertMsg"
      :btnRight="'확인'"
      :oneBtn="false"
      :isShow="showAlert"
      :className="'btn_brown'"
      :closeEventValue="closeEventValue"
      @closeEvent="fn_alert_close_event"
      v-on:update:showSetting="fn_showSet"
    />
  </b-modal>
</template>

<script>
import axios from 'axios'
import AlertModal from "@/modal/common/alertModal.vue"
import alertutill from "@/mixin/alertModalUtill";
import commonUtil from "@/mixin/commonUtil";

export default {
  name: 'bibangReviewRegModal',
  components: {
    AlertModal
  },
  mixins: [commonUtil,alertutill],
  data() {
    return {
      prescribe_seq: '',
      secret_prescription_seq: '',
      secret_clinic_doctor_id: '',
      write_clinic_doctor_id: '',

      questionGroups: [
        { key: 'symptom_change', codeGroup: 'GC00000046', title: '처방 후 증상은 어떻게 변했나요?', options: [] },
        { key: 'side_effect', codeGroup: 'GC00000047', title: '부작용이나 불편 반응이 있었나요?', options: [] },
        { key: 'usage_type', codeGroup: 'GC00000048', title: '처방 사용방법?', options: [] },
        { key: 'eval_period', codeGroup: 'GC00000049', title: '처방 후 언제 평가한 결과인가요? (처방일 기준)', options: [] },
        { key: 'medication_adherence', codeGroup: 'GC00000050', title: '환자는 처방약을 얼마나 복용했나요?', options: [] }
      ],
      ratingOptions: [],

      answers: {
        symptom_change: '',
        side_effect: '',
        usage_type: '',
        eval_period: '',
        medication_adherence: ''
      },
      modification_note: '',
      clinical_rating: 0,
      review_contents: ''
    };
  },
  async created() {
    await this.fn_init_code();
  },
  methods: {
    async fn_init_code() {
      // GC00000046~50: symptom_change/side_effect/usage_type/eval_period/medication_adherence 순서 매핑
      // GC00000051: ratingOptions. DB dtl_code 값이 아래 usage_type 'MODIFIED' 분기 및 rating 숫자 비교와 일치해야 함
      const codeList = await this.getCodeList([
        'GC00000046',
        'GC00000047',
        'GC00000048',
        'GC00000049',
        'GC00000050',
        'GC00000051'
      ]);

      this.questionGroups.forEach(group => {
        group.options = (codeList[group.codeGroup] || []).map(item => ({
          code: item.dtl_code,
          label: item.dtl_code_nm
        }));
      });

      this.ratingOptions = (codeList['GC00000051'] || []).map(item => ({
        value: Number(item.dtl_code),
        label: item.dtl_code_nm
      }));
    },
    open(item, writeClinicDoctorId) {
      this.prescribe_seq = item.prescribe_seq;
      this.secret_prescription_seq = item.secret_prescription_seq;
      this.secret_clinic_doctor_id = item.secret_clinic_doctor_id;
      this.write_clinic_doctor_id = writeClinicDoctorId;

      this.$bvModal.show('bibangReviewRegModal');
    },
    fn_select_answer(key, code) {
      this.answers[key] = code;

      // 'MODIFIED'는 GC00000048의 dtl_code 값과 일치해야 함
      if (key === 'usage_type' && code !== 'MODIFIED') {
        this.modification_note = '';
      }
    },
    fn_close_review(ok) {
      ok();
    },
    fn_reset() {
      this.prescribe_seq = '';
      this.secret_prescription_seq = '';
      this.secret_clinic_doctor_id = '';
      this.write_clinic_doctor_id = '';

      this.answers = {
        symptom_change: '',
        side_effect: '',
        usage_type: '',
        eval_period: '',
        medication_adherence: ''
      };
      this.modification_note = '';
      this.clinical_rating = 0;
      this.review_contents = '';
    },
    fn_reg_review() {
      let param = new Object();
      param.prescribe_seq = this.prescribe_seq;
      param.secret_prescription_seq = this.secret_prescription_seq;
      param.secret_clinic_doctor_id = this.secret_clinic_doctor_id;
      param.write_clinic_doctor_id = this.write_clinic_doctor_id;
      param.symptom_change = this.answers.symptom_change;
      param.side_effect = this.answers.side_effect;
      param.usage_type = this.answers.usage_type;
      // 'MODIFIED'는 GC00000048의 dtl_code 값과 일치해야 함
      param.modification_note = this.answers.usage_type === 'MODIFIED' ? this.modification_note : '';
      param.eval_period = this.answers.eval_period;
      param.medication_adherence = this.answers.medication_adherence;
      // rating은 GC00000051의 dtl_code를 숫자로 변환한 값(fn_init_code 참고)
      param.clinical_rating = this.clinical_rating;
      param.review_contents = this.review_contents;

      console.log("@@@@ param : %o", param);

      axios
        .post("/api/user/mypage/regScretPrescriptionReview", param)
        .then((res) => {
          console.log("@@@@ res : %o", res);

          let msg = "저장되었습니다.";
          this.fn_open_alert_close(msg);
        })
        .catch((err) => console.log(err));
    },
    fn_alert_close_event() {
      this.$bvModal.hide('bibangReviewRegModal');
      this.$emit('saved');
    }
  }
};
</script>

<style scoped>
.review_form {
  max-height: 60vh;
  overflow-y: auto;
  padding-right: 10px;
}
.qa_block {
  margin-bottom: 20px;
}
.qa_title {
  font-weight: bold;
  margin-bottom: 8px;
}
.qa_sub_title {
  font-size: 1.3rem;
  color: #666;
  margin: 10px 0 6px;
}
.card_select {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.card_option {
  padding: 8px 14px;
  border: 1px solid #ddd;
  border-radius: 6px;
  background-color: #fff;
  color: #666;
  cursor: pointer;
  font-size: 1.4rem;
  transition: all 0.15s ease-in-out;
}
.card_option:hover {
  border-color: #78420c;
  color: #78420c;
}
.card_option.active {
  border-color: #78420c;
  background-color: #78420c;
  color: #fff;
  font-weight: bold;
}
.modify_note {
  margin-top: 10px;
}
.modify_note .form_control {
  height: 34px;
  line-height: 34px;
  padding: 0 1em;
}
</style>